{
  "actual_edges": [
    {
      "from": "w1",
      "id": "w1-to-w2",
      "kind": "actual",
      "to": "w2"
    },
    {
      "from": "w2",
      "id": "w2-to-w3",
      "kind": "actual",
      "to": "w3"
    },
    {
      "from": "w3",
      "id": "w3-to-w4",
      "kind": "actual",
      "to": "w4"
    },
    {
      "from": "w4",
      "id": "w4-to-w5",
      "kind": "actual",
      "to": "w5"
    },
    {
      "from": "w5",
      "id": "w5-to-w6",
      "kind": "actual",
      "to": "w6"
    },
    {
      "from": "w6",
      "id": "w6-to-w7",
      "kind": "actual",
      "to": "w7"
    },
    {
      "from": "w7",
      "id": "w7-to-w8",
      "kind": "actual",
      "to": "w8"
    },
    {
      "from": "w8",
      "id": "w8-to-w9",
      "kind": "actual",
      "to": "w9"
    },
    {
      "from": "w9",
      "id": "w9-to-w10",
      "kind": "actual",
      "to": "w10"
    },
    {
      "from": "w10",
      "id": "w10-to-w11",
      "kind": "actual",
      "to": "w11"
    },
    {
      "from": "w11",
      "id": "w11-to-w12",
      "kind": "actual",
      "to": "w12"
    },
    {
      "from": "w12",
      "id": "w12-to-w13",
      "kind": "actual",
      "to": "w13"
    },
    {
      "from": "w13",
      "id": "w13-to-w14",
      "kind": "actual",
      "to": "w14"
    },
    {
      "from": "w14",
      "id": "w14-to-w15",
      "kind": "actual",
      "to": "w15"
    },
    {
      "from": "w15",
      "id": "w15-to-w16",
      "kind": "actual",
      "to": "w16"
    },
    {
      "from": "w16",
      "id": "w16-to-w17",
      "kind": "actual",
      "to": "w17"
    },
    {
      "from": "w17",
      "id": "w17-to-w18",
      "kind": "actual",
      "to": "w18"
    },
    {
      "from": "w18",
      "id": "w18-to-w19",
      "kind": "actual",
      "to": "w19"
    }
  ],
  "agent_commit": "c96f2ed3595162a174e680b563337f6215f6eace",
  "branch_semantics": {
    "available_actions": "legal-actions-not-future-state-branches",
    "event_choices": "legal-options-not-executed-unless-selected",
    "projected_counterfactual_states": false
  },
  "campaign_id": "playthrough-evidence-full-v1",
  "cell_id": "newbie-seed-42-800280af3dc4",
  "completed_weeks": 19,
  "difficulty": "normal",
  "final_ending": "cashflow_collapse",
  "game_commit": "348b9fd5501e71ebc7142e10f9068fc1490b5124",
  "game_tree": "225cd5451d09bb92da674234a79ecaf8db4beb3a",
  "nodes": [
    {
      "anomalies": [],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_school_germany",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "student_club",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 12,
        "energy": -52,
        "exam_readiness": 17,
        "hunger": 2,
        "language": 19,
        "money": -358,
        "social": 5,
        "stress": 12
      },
      "event": {
        "id": "arrival",
        "legal_choices": [
          {
            "choice_id": "arrival.choice_01_先去宿舍放行李",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived",
            "success_effects": {
              "energy": 10.0,
              "stress": -4.0
            },
            "success_rate": 1.0,
            "text": "先去宿舍放行李"
          },
          {
            "choice_id": "arrival.choice_02_立刻去超市和_dm_补生活用品",
            "failure_effects": {
              "energy": -6.0,
              "hunger": 6.0,
              "money": -55.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived_supplied",
            "success_effects": {
              "energy": -6.0,
              "hunger": -10.0,
              "money": -55.0,
              "stress": -3.0
            },
            "success_rate": 1.0,
            "text": "立刻去超市和 dm 补生活用品"
          },
          {
            "choice_id": "arrival.choice_03_先激活_sim_卡和银行_app",
            "failure_effects": {
              "stress": 8.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003
            },
            "set_flag": "arrived",
            "success_effects": {
              "language": 1.0,
              "stress": 4.0,
              "visa_progress": 4.0
            },
            "success_rate": 0.746,
            "text": "先激活 SIM 卡和银行 App"
          },
          {
            "choice_id": "arrival.choice_04_坐在车站缓一缓",
            "failure_effects": {
              "money": -25.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "arrived",
            "success_effects": {
              "loneliness": 4.0,
              "money": -25.0,
              "stress": -8.0,
              "visa_progress": -2.0
            },
            "success_rate": 1.0,
            "text": "坐在车站缓一缓"
          }
        ],
        "selected_choice_id": "arrival.choice_02_立刻去超市和_dm_补生活用品"
      },
      "evidence": {
        "decision_request_fingerprint": "e88d5a931303c780beeb552eff490ddfb80093afa21c35b0d3c603fcc826074d",
        "event_request_fingerprint": "7200b246b888f0d2db0a73cd8d0f3723c7cc8c8a6cc7c69186c87a7f2986f489",
        "source_line": 1,
        "source_record_sha256": "0f504adaf1bc3ded0651d8e2a5167a3a410a6fa66c06fe5041b50dfe89abb74c"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 12,
        "blocked_account_balance": -992,
        "energy": -52,
        "exam_readiness": 17,
        "hunger": 2,
        "language": 19,
        "money": -358,
        "social": 5,
        "stress": 12,
        "unpaid_social_streak": 2,
        "week": 1
      },
      "id": "w1",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 2,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 4 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 84,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 70,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          },
          {
            "body": "当前可支配现金 142 EUR，逾期 0 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 58,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "language_school_germany",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 22,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 48,
        "exam_readiness": 28,
        "failed_courses": 0,
        "flags": {
          "arrived_supplied": true,
          "housing_contract_active": true
        },
        "gpa_score": 61,
        "hunger": 27,
        "language": 39,
        "loneliness": 30,
        "money": 142,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 20,
        "stress": 32,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 2,
        "visa_progress": 15,
        "week": 2,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 10,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 11904,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 100,
        "exam_readiness": 11,
        "failed_courses": 0,
        "flags": {},
        "gpa_score": 61,
        "hunger": 25,
        "language": 20,
        "loneliness": 30,
        "money": 500,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 15,
        "stress": 20,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 0,
        "visa_progress": 15,
        "week": 1,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 1
    },
    {
      "anomalies": [],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "student_club",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 10,
        "energy": -16,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 14,
        "loneliness": 2,
        "money": -102,
        "social": 3,
        "stress": 14,
        "visa_progress": 2
      },
      "event": {
        "id": "germany_language_track_start",
        "legal_choices": [
          {
            "choice_id": "germany_language_track_start.choice_01_报名密集语言班",
            "failure_effects": {
              "language": -1.0,
              "money": -420.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "language": 10.0,
              "money": -420.0,
              "stress": 6.0
            },
            "success_rate": 1.0,
            "text": "报名密集语言班"
          },
          {
            "choice_id": "germany_language_track_start.choice_02_先自学一周省钱",
            "failure_effects": {
              "language": -1.0,
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -4.0,
              "language": 4.0,
              "money": 40.0,
              "stress": 5.0
            },
            "success_rate": 1.0,
            "text": "先自学一周省钱"
          },
          {
            "choice_id": "germany_language_track_start.choice_03_问学校能否条件注册",
            "failure_effects": {
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "stress": 4.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.506,
            "text": "问学校能否条件注册"
          },
          {
            "choice_id": "germany_language_track_start.choice_04_找便宜语言学校",
            "failure_effects": {
              "language": 2.0,
              "money": -220.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "language": 6.0,
              "money": -260.0,
              "stress": 8.0
            },
            "success_rate": 0.606,
            "text": "找便宜语言学校"
          }
        ],
        "selected_choice_id": "germany_language_track_start.choice_02_先自学一周省钱"
      },
      "evidence": {
        "decision_request_fingerprint": "16b6520d8ff027600744d3c1c40b7e299a2c671cbf794482d435df6e2f1f4901",
        "event_request_fingerprint": "bbe7ea114644c2b97760f325fe0b30102a9af3cf7209600c56533ec4cb89a26d",
        "source_line": 2,
        "source_record_sha256": "0ed086cd067b461e005620f1bb34310104a7e06e00a38c9df55a1a035c783d42"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 10,
        "arrears_amount": 113,
        "cash_shortfall_count": 1,
        "energy": -16,
        "exam_readiness": 17,
        "hunger": 12,
        "language": 14,
        "loneliness": 2,
        "money": -102,
        "social": 3,
        "stress": 14,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w2",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 3,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 3 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 91,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前可支配现金 40 EUR，逾期 113 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 78,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 70,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 32,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 113,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 1,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 45,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 39,
        "language": 53,
        "loneliness": 32,
        "money": 40,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 23,
        "stress": 46,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 4,
        "visa_progress": 17,
        "week": 3,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 22,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 0,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 0,
        "current_week_work_hours": 0,
        "energy": 48,
        "exam_readiness": 28,
        "failed_courses": 0,
        "flags": {
          "arrived_supplied": true,
          "housing_contract_active": true
        },
        "gpa_score": 61,
        "hunger": 27,
        "language": 39,
        "loneliness": 30,
        "money": 142,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 20,
        "stress": 32,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 2,
        "visa_progress": 15,
        "week": 2,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 2
    },
    {
      "anomalies": [],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": 17,
        "hunger": 24,
        "language": 10,
        "loneliness": 3,
        "money": -40,
        "social": 1,
        "stress": 25,
        "visa_progress": 2
      },
      "event": {
        "id": "missing_school_registration",
        "legal_choices": [
          {
            "choice_id": "missing_school_registration.choice_02_先找_international_office",
            "failure_effects": {
              "academic_progress": -7.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "school_registered",
            "success_effects": {
              "academic_progress": -3.0,
              "stress": 4.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.89,
            "text": "先找 International Office"
          },
          {
            "choice_id": "missing_school_registration.choice_03_只靠自学顶一周",
            "failure_effects": {
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -6.0,
              "hunger": 5.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "只靠自学顶一周"
          },
          {
            "choice_id": "missing_school_registration.choice_04_继续拖延",
            "failure_effects": {
              "money": -80.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -10.0,
              "money": -80.0,
              "stress": 8.0
            },
            "success_rate": 1.0,
            "text": "继续拖延"
          }
        ],
        "selected_choice_id": "missing_school_registration.choice_02_先找_international_office"
      },
      "evidence": {
        "decision_request_fingerprint": "2717cc262def1a496393d9138869b40a35c15158065aa43ae57aaf15d4f5de01",
        "event_request_fingerprint": "32f6bd416ac8a9a3a97bb38db57751e9beb4d309cb962a5f300f72d62776cfc8",
        "source_line": 3,
        "source_record_sha256": "6f03cbcb028f31651e51815d98a959f2a5204fa79934f76033a7e7c55addca5d"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 215,
        "cash_shortfall_count": 1,
        "exam_readiness": 17,
        "hunger": 24,
        "language": 10,
        "loneliness": 3,
        "money": -40,
        "social": 1,
        "stress": 25,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w3",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 4,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 2 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 98,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "当前 TestDaF 2/2/2/2。没过 4x4 会卡注册并增加语言班成本。",
            "id": "testdaf",
            "score": 82,
            "suggested_actions": [
              "language_school_germany",
              "testdaf_exam_germany"
            ],
            "title": "TestDaF 4x4"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 328 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 78,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 39,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 328,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 2,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 62,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 63,
        "language": 63,
        "loneliness": 35,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 24,
        "stress": 71,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 6,
        "visa_progress": 19,
        "week": 4,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 32,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 113,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 1,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 45,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 39,
        "language": 53,
        "loneliness": 32,
        "money": 40,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 23,
        "stress": 46,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 4,
        "visa_progress": 17,
        "week": 3,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 3
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 4,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        }
      ],
      "attractors": [
        "burnout-risk"
      ],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 12,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 34,
        "language": 10,
        "loneliness": 3,
        "social": 4,
        "stress": 25,
        "visa_progress": 8
      },
      "event": {
        "id": "wg_interview",
        "legal_choices": [
          {
            "choice_id": "wg_interview.choice_01_表现得非常德式",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "housing_stable",
            "success_effects": {
              "social": 3.0,
              "visa_progress": 6.0
            },
            "success_rate": 0.73,
            "text": "表现得非常德式"
          },
          {
            "choice_id": "wg_interview.choice_02_说自己会做中餐",
            "failure_effects": {
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "wg_cooking",
            "success_effects": {
              "hunger": -6.0,
              "loneliness": -4.0,
              "social": 7.0
            },
            "success_rate": 0.635,
            "text": "说自己会做中餐"
          },
          {
            "choice_id": "wg_interview.choice_03_坦白预算很紧",
            "failure_effects": {
              "social": -3.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "cheap_room_hint",
            "success_effects": {
              "money": 120.0,
              "stress": 5.0
            },
            "success_rate": 0.286,
            "text": "坦白预算很紧"
          },
          {
            "choice_id": "wg_interview.choice_04_过度迎合每条规则",
            "failure_effects": {
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002
            },
            "set_flag": "housing_stable",
            "success_effects": {
              "energy": -6.0,
              "social": 2.0,
              "stress": 8.0
            },
            "success_rate": 0.431,
            "text": "过度迎合每条规则"
          }
        ],
        "selected_choice_id": "wg_interview.choice_01_表现得非常德式"
      },
      "evidence": {
        "decision_request_fingerprint": "cdce326d3e7d90e0de4fca7fdfc0fbf64bfeedf71495236a53e163b69df13f81",
        "event_request_fingerprint": "c559d36658277bb33955dea15bc619d36027b584a504746d1d4dcb2b25ef2f7e",
        "source_line": 4,
        "source_record_sha256": "be5f60803645d9c1b0bfdfddeed699fa3459df69597436025de3dee20140d330"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 12,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 34,
        "language": 10,
        "loneliness": 3,
        "social": 4,
        "stress": 25,
        "unpaid_social_streak": 2,
        "visa_progress": 8,
        "week": 1
      },
      "id": "w4",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 5,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 1 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 100,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "饥饿 97。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 97,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 583 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 51,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 583,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 79,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 97,
        "language": 73,
        "loneliness": 38,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 28,
        "stress": 96,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 8,
        "visa_progress": 27,
        "week": 5,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 39,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 328,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 2,
        "current_week_work_hours": 0,
        "energy": 32,
        "exam_readiness": 62,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "housing_contract_active": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 63,
        "language": 63,
        "loneliness": 35,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 24,
        "stress": 71,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 6,
        "visa_progress": 19,
        "week": 4,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 4
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 5,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 7,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 3,
        "language": 10,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": 4,
        "visa_progress": 5
      },
      "event": {
        "id": "legal_work_limit_notice",
        "legal_choices": [
          {
            "choice_id": "legal_work_limit_notice.choice_01_把工时记进日历",
            "failure_effects": {
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "stress": 2.0,
              "visa_progress": 3.0
            },
            "success_rate": 1.0,
            "text": "把工时记进日历"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_02_只接合同清楚的班",
            "failure_effects": {
              "career_progress": -1.0,
              "money": -40.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "career_progress": 3.0,
              "money": -40.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "只接合同清楚的班"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_03_问_asta/international_office",
            "failure_effects": {
              "language": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "language": 2.0,
              "stress": -1.0,
              "visa_progress": 4.0
            },
            "success_rate": 1.0,
            "text": "问 AStA/International Office"
          },
          {
            "choice_id": "legal_work_limit_notice.choice_04_觉得自己不会超",
            "failure_effects": {
              "stress": 4.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "work_law_briefed",
            "success_effects": {
              "stress": -2.0
            },
            "success_rate": 0.316,
            "text": "觉得自己不会超"
          }
        ],
        "selected_choice_id": "legal_work_limit_notice.choice_01_把工时记进日历"
      },
      "evidence": {
        "decision_request_fingerprint": "7207201f2c06614a6fcc99a82e452e14b970299797fe6d631bf0271244598702",
        "event_request_fingerprint": "ed25f1dd3cb5f37fa0156ba011633b605e9c47bf592e983424bdf61e3389ae07",
        "source_line": 5,
        "source_record_sha256": "7c18d6b11ad878ce4e6c34f5962c38ef785f18af8dbac1fc862146f9071674a4"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "blocked_account_balance": -992,
        "energy": -8,
        "exam_readiness": 17,
        "hunger": 3,
        "language": 10,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": 4,
        "unpaid_social_streak": 2,
        "visa_progress": 5,
        "week": 1
      },
      "id": "w5",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 6,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "还剩 0 周。没有 TestDaF 4x4 或注册材料，本学期会被拖后。",
            "id": "registration",
            "score": 100,
            "suggested_actions": [
              "school_registration",
              "insurance_paperwork",
              "testdaf_exam_germany"
            ],
            "title": "学校注册窗口"
          },
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 58,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 583,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 83,
        "loneliness": 41,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 29,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 10,
        "visa_progress": 32,
        "week": 6,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 51,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 583,
        "blocked_account_balance": 10912,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 24,
        "exam_readiness": 79,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true
        },
        "gpa_score": 61,
        "hunger": 97,
        "language": 73,
        "loneliness": 38,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 28,
        "stress": 96,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 8,
        "visa_progress": 27,
        "week": 5,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 5
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 6,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        }
      ],
      "attractors": [
        "cashflow-stress-attractor"
      ],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "school_registration_deadline",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 7,
        "exam_readiness": 4,
        "language": 10,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "stress": -5,
        "visa_progress": -6
      },
      "event": {
        "id": "anmeldung_deadline",
        "legal_choices": [
          {
            "choice_id": "anmeldung_deadline.choice_01_立刻补材料",
            "failure_effects": {
              "energy": -4.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": -4.0,
              "stress": 4.0,
              "visa_progress": 7.0
            },
            "success_rate": 1.0,
            "text": "立刻补材料"
          },
          {
            "choice_id": "anmeldung_deadline.choice_02_先问_international_office",
            "failure_effects": {
              "language": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "language": 1.0,
              "stress": -2.0,
              "visa_progress": 5.0
            },
            "success_rate": 1.0,
            "text": "先问 International Office"
          },
          {
            "choice_id": "anmeldung_deadline.choice_03_请室友确认_wohnungsgeberbestätigung",
            "failure_effects": {
              "stress": 6.0,
              "visa_progress": -2.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002,
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "social": 3.0,
              "stress": 1.0,
              "visa_progress": 6.0
            },
            "success_rate": 0.845,
            "text": "请室友确认 Wohnungsgeberbestätigung"
          },
          {
            "choice_id": "anmeldung_deadline.choice_04_把信封塞进抽屉",
            "failure_effects": {
              "money": -30.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "admin_avoidance",
            "success_effects": {
              "money": -30.0,
              "stress": -5.0,
              "visa_progress": -8.0
            },
            "success_rate": 1.0,
            "text": "把信封塞进抽屉"
          }
        ],
        "selected_choice_id": "anmeldung_deadline.choice_04_把信封塞进抽屉"
      },
      "evidence": {
        "decision_request_fingerprint": "2f25876cd20a20a7d6a42385d6cc4d77c9c7c3278eccc3c4c3ac185b6fb24684",
        "event_request_fingerprint": "3f1ce48821b9f29e900c921400e3f7906018f46bb95b11e3b86c05d69f235a21",
        "source_line": 6,
        "source_record_sha256": "18674b7ddd81adc11da3ed9f5e8b4249d34cac946742e133689d082ba18fb640"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 168,
        "cash_shortfall_count": 2,
        "exam_readiness": 4,
        "language": 10,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "stress": -5,
        "unpaid_social_streak": 2,
        "visa_progress": -6,
        "week": 1
      },
      "id": "w6",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 7,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 751 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "压力 95。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 95,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 65,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 751,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 5,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 93,
        "loneliness": 44,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 30,
        "stress": 95,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 12,
        "visa_progress": 26,
        "week": 7,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 58,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 583,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 3,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 96,
        "failed_courses": 0,
        "flags": {
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 83,
        "loneliness": 41,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 29,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 10,
        "visa_progress": 32,
        "week": 6,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 6
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 7,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "international_office",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": -5,
        "language": 7,
        "loneliness": 3,
        "social": 1,
        "stress": 5,
        "visa_progress": 4
      },
      "event": {
        "id": "registration_window_missed",
        "legal_choices": [
          {
            "choice_id": "registration_window_missed.choice_01_接受下学期再注册",
            "failure_effects": {
              "money": -650.0,
              "stress": 2.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -12.0,
              "money": -650.0,
              "stress": 14.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "接受下学期再注册"
          },
          {
            "choice_id": "registration_window_missed.choice_03_转入语言班等待下学期",
            "failure_effects": {
              "language": -1.0,
              "money": -900.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -9.0,
              "language": 8.0,
              "money": -900.0,
              "stress": 10.0
            },
            "success_rate": 1.0,
            "text": "转入语言班等待下学期"
          },
          {
            "choice_id": "registration_window_missed.choice_04_逃避邮件和截止日",
            "failure_effects": {
              "money": -420.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "registration_delayed",
            "success_effects": {
              "academic_progress": -16.0,
              "hunger": 8.0,
              "money": -420.0,
              "stress": 22.0
            },
            "success_rate": 1.0,
            "text": "逃避邮件和截止日"
          }
        ],
        "selected_choice_id": "registration_window_missed.choice_01_接受下学期再注册"
      },
      "evidence": {
        "decision_request_fingerprint": "3299bfc327e56a031a843a5dddc20f4ddd737a6363a58f726af702e31b4be363",
        "event_request_fingerprint": "a6d77184ab651ccf30616ba5479aa968e1edc146d349dde618b9394beffed8ab",
        "source_line": 7,
        "source_record_sha256": "a45851d8ecc6677b8a43f29033c07960d6ead7122d210d96bfe1a78c7ccd7c1a"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -5,
        "arrears_amount": 905,
        "cash_shortfall_count": 2,
        "language": 7,
        "loneliness": 3,
        "social": 1,
        "stress": 5,
        "unpaid_social_streak": 2,
        "visa_progress": 4,
        "week": 1
      },
      "id": "w7",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 8,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 1656 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 60,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1656,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 7,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 47,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 31,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 14,
        "visa_progress": 30,
        "week": 8,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 65,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 751,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 5,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 93,
        "loneliness": 44,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 30,
        "stress": 95,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 12,
        "visa_progress": 26,
        "week": 7,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 7
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 8,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "insurance_paperwork",
        "bank_account",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 7,
        "loneliness": 3,
        "money": 70,
        "social": 3,
        "stress": -2,
        "visa_progress": 2
      },
      "event": {
        "id": "parents_money_hint",
        "legal_choices": [
          {
            "choice_id": "parents_money_hint.choice_01_做预算表给他们看",
            "failure_effects": {
              "money": -35.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 120.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "做预算表给他们看"
          },
          {
            "choice_id": "parents_money_hint.choice_02_先安慰他们",
            "failure_effects": {
              "loneliness": 2.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": -3.0,
              "stress": 2.0
            },
            "success_rate": 1.0,
            "text": "先安慰他们"
          },
          {
            "choice_id": "parents_money_hint.choice_03_稳妥处理",
            "failure_effects": {
              "money": 35.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 105.0,
              "stress": 1.0
            },
            "success_rate": 0.412,
            "text": "稳妥处理"
          },
          {
            "choice_id": "parents_money_hint.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "money": 70.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.63,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "parents_money_hint.choice_04_寻求帮助"
      },
      "evidence": {
        "decision_request_fingerprint": "7e6f1c20709a0d5f03becf7efff52f4ecd89aedcd8fea609ec041c1a4c5da203",
        "event_request_fingerprint": "c749d10cddc609ce36a889ff75ae829c7c5da422aed68703f0e64cce93c078d6",
        "source_line": 8,
        "source_record_sha256": "c883ce852fc4386330da9e2c87701673e06a66bb4d85718e97eecb8203c1bf23"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 7,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "money": 70,
        "social": 3,
        "stress": -2,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w8",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 9,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "压力 98。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 98,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 70 EUR，逾期 1911 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 67,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1911,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 50,
        "money": 70,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 98,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 16,
        "visa_progress": 32,
        "week": 9,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 60,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1656,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 7,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 47,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 31,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 14,
        "visa_progress": 30,
        "week": 8,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 8
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exam_registration",
              "max_weeks": 9,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 9
            },
            "streak_weeks": 6,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 6 consecutive weeks (week=9).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 9
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "bank_account",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 8,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": 2,
        "visa_progress": 2
      },
      "event": {
        "id": "exam_registration",
        "legal_choices": [
          {
            "choice_id": "exam_registration.choice_01_马上报名",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0,
              "visa_progress": -1.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "exam_registered",
            "success_effects": {
              "academic_progress": 2.0,
              "exam_readiness": 4.0,
              "stress": -3.0,
              "visa_progress": 2.0
            },
            "success_rate": 1.0,
            "text": "马上报名"
          },
          {
            "choice_id": "exam_registration.choice_02_报名后顺手查考纲",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "exam_registered",
            "success_effects": {
              "academic_progress": 1.0,
              "exam_readiness": 7.0,
              "stress": 1.0
            },
            "success_rate": 1.0,
            "text": "报名后顺手查考纲"
          },
          {
            "choice_id": "exam_registration.choice_03_先问同学报名流程",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "exam_registered",
            "success_effects": {
              "exam_readiness": 3.0,
              "social": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.641,
            "text": "先问同学报名流程"
          },
          {
            "choice_id": "exam_registration.choice_04_晚点再说",
            "failure_effects": {
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "exam_readiness": -4.0,
              "stress": 5.0
            },
            "success_rate": 1.0,
            "text": "晚点再说"
          }
        ],
        "selected_choice_id": "exam_registration.choice_02_报名后顺手查考纲"
      },
      "evidence": {
        "decision_request_fingerprint": "a9baa21058bff3e6277ca6c37462cc1de4bdc383783150890e1a52de1a6861a9",
        "event_request_fingerprint": "066760b3a7c12482057bf05d055e5832537bd7619285e83a3d9d6f93821e4aae",
        "source_line": 9,
        "source_record_sha256": "08f43c023158b80a16db7026d2b456759f73fe4b9c7c02c5392e4199b734009c"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 8,
        "blocked_account_balance": -992,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "stress": 2,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w9",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 10,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 187 EUR，逾期 1911 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 75,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1911,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 53,
        "money": 187,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 35,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 18,
        "visa_progress": 34,
        "week": 10,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 67,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1911,
        "blocked_account_balance": 9920,
        "career_progress": 0,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 50,
        "money": 70,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 34,
        "stress": 98,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 16,
        "visa_progress": 32,
        "week": 9,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 9
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "midterm_pressure",
              "max_weeks": 10,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 10
            },
            "streak_weeks": 7,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 7 consecutive weeks (week=10).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 10
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "anmeldung",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "therapy",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 14,
        "loneliness": 3,
        "money": -187,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "midterm_pressure",
        "legal_choices": [
          {
            "choice_id": "midterm_pressure.choice_01_整理学习计划",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 5.0,
              "exam_readiness": 4.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "整理学习计划"
          },
          {
            "choice_id": "midterm_pressure.choice_02_先睡一觉",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -2.0,
              "energy": 16.0,
              "exam_readiness": -2.0,
              "stress": -6.0
            },
            "success_rate": 1.0,
            "text": "先睡一觉"
          },
          {
            "choice_id": "midterm_pressure.choice_03_砍掉一班打工补作业",
            "failure_effects": {
              "academic_progress": -1.0,
              "money": -139.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 7.0,
              "exam_readiness": 5.0,
              "money": -139.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "砍掉一班打工补作业"
          },
          {
            "choice_id": "midterm_pressure.choice_04_靠咖啡硬顶",
            "failure_effects": {
              "academic_progress": -1.0,
              "energy": -12.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 4.0,
              "energy": -12.0,
              "exam_readiness": 2.0,
              "stress": 10.0
            },
            "success_rate": 1.0,
            "text": "靠咖啡硬顶"
          }
        ],
        "selected_choice_id": "midterm_pressure.choice_03_砍掉一班打工补作业"
      },
      "evidence": {
        "decision_request_fingerprint": "7493e4346d689b8d6944d8f42184b0b15fbff009644b4b5b4bf80491cf6433e3",
        "event_request_fingerprint": "3ff2446e25e8ba7e19e23792983e00871ef5e2dd14b70c0d3eb2b78001a2c6ed",
        "source_line": 10,
        "source_record_sha256": "628ab21e0bcc7c91fda93a49b9fe0dacf4e3ffa482818d043260c53b22a30db1"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 14,
        "arrears_amount": 207,
        "cash_shortfall_count": 2,
        "loneliness": 3,
        "money": -187,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w10",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 11,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2118 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 89,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2118,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 10,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 56,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 36,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 20,
        "visa_progress": 36,
        "week": 11,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 75,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 1911,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 8,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 53,
        "money": 187,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 35,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 18,
        "visa_progress": 34,
        "week": 10,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 10
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wechat_silence",
              "max_weeks": 11,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 11
            },
            "streak_weeks": 8,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 8 consecutive weeks (week=11).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 11
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 4,
        "loneliness": -2,
        "social": 1,
        "stress": -2,
        "visa_progress": 2
      },
      "event": {
        "id": "wechat_silence",
        "legal_choices": [
          {
            "choice_id": "wechat_silence.choice_01_写一段真实记录",
            "failure_effects": {
              "loneliness": 2.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "loneliness": -5.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "写一段真实记录"
          },
          {
            "choice_id": "wechat_silence.choice_02_继续潜水",
            "failure_effects": {
              "energy": -4.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 2.0,
              "loneliness": 3.0
            },
            "success_rate": 1.0,
            "text": "继续潜水"
          },
          {
            "choice_id": "wechat_silence.choice_03_稳妥处理",
            "failure_effects": {
              "energy": 0.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "stress": -2.0
            },
            "success_rate": 0.196,
            "text": "稳妥处理"
          },
          {
            "choice_id": "wechat_silence.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 1.0,
              "social": 2.0,
              "stress": -4.0
            },
            "success_rate": 0.415,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "wechat_silence.choice_01_写一段真实记录"
      },
      "evidence": {
        "decision_request_fingerprint": "574f71cb88dbad37c28c25b98577e7894f642d722bb6a24d0ec52d347d4433e8",
        "event_request_fingerprint": "58723c9d2a12366e244ea054bb83a80fb4b2375066114358fd8e7ae35adc64e4",
        "source_line": 11,
        "source_record_sha256": "92123f2f057359b2d0192a851f5f698006ff414f91f88430f7fb027cf2020f9e"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 4,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": -2,
        "social": 1,
        "stress": -2,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w11",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 12,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "压力 98。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 98,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2373 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2373,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 54,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 37,
        "stress": 98,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 22,
        "visa_progress": 38,
        "week": 12,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 89,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2118,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 10,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 56,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 36,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 20,
        "visa_progress": 36,
        "week": 11,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 11
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "group_invite",
              "max_weeks": 12,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 12
            },
            "streak_weeks": 9,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 9 consecutive weeks (week=12).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 12
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "loneliness": 3,
        "social": 1,
        "stress": 2,
        "visa_progress": 2
      },
      "event": {
        "id": "group_invite",
        "legal_choices": [
          {
            "choice_id": "group_invite.choice_01_答应并主动分工",
            "failure_effects": {
              "stress": 5.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.002,
              "social": 0.003
            },
            "set_flag": "anna_group",
            "success_effects": {
              "academic_progress": 6.0,
              "exam_readiness": 4.0,
              "language": 3.0,
              "social": 8.0
            },
            "success_rate": 0.9,
            "text": "答应并主动分工"
          },
          {
            "choice_id": "group_invite.choice_02_只接资料整理的部分",
            "failure_effects": {
              "academic_progress": -1.0,
              "social": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "anna_group",
            "success_effects": {
              "academic_progress": 4.0,
              "exam_readiness": 2.0,
              "social": 3.0,
              "stress": 2.0
            },
            "success_rate": 1.0,
            "text": "只接资料整理的部分"
          },
          {
            "choice_id": "group_invite.choice_03_请她先解释评分标准",
            "failure_effects": {
              "stress": 6.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003,
              "social": 0.002
            },
            "set_flag": "anna_group",
            "success_effects": {
              "exam_readiness": 6.0,
              "language": 3.0,
              "social": 5.0
            },
            "success_rate": 0.85,
            "text": "请她先解释评分标准"
          },
          {
            "choice_id": "group_invite.choice_04_委婉拒绝",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "social": -4.0,
              "stress": -3.0
            },
            "success_rate": 1.0,
            "text": "委婉拒绝"
          }
        ],
        "selected_choice_id": "group_invite.choice_03_请她先解释评分标准"
      },
      "evidence": {
        "decision_request_fingerprint": "d576fb02fcf5511c45cffcb59486316a60f03129a1049be15711ee3f762d425f",
        "event_request_fingerprint": "4043f807f70e8491904cdb4cf3af0143eb349f6c9b0a5cb342251480cba362d3",
        "source_line": 12,
        "source_record_sha256": "024cf3c1fe1782bbc95e5bc2eec4418be6859b464216b5387523a2ebe923509d"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "social": 1,
        "stress": 2,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w12",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 13,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2628 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2628,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 57,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 38,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 24,
        "visa_progress": 40,
        "week": 13,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2373,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 11,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 54,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 37,
        "stress": 98,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 22,
        "visa_progress": 38,
        "week": 12,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 12
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exercise_sheet_warning",
              "max_weeks": 13,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 13
            },
            "streak_weeks": 10,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 10 consecutive weeks (week=13).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 13
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 3,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "exercise_sheet_warning",
        "legal_choices": [
          {
            "choice_id": "exercise_sheet_warning.choice_01_补三套练习题",
            "failure_effects": {
              "exam_readiness": 2.0,
              "stress": 10.0
            },
            "next_event_id": "",
            "requirements": {
              "academic_progress": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "exam_readiness": 10.0,
              "stress": 6.0
            },
            "success_rate": 0.775,
            "text": "补三套练习题"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_02_去_tutorium_问清楚",
            "failure_effects": {
              "stress": 7.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 7.0,
              "language": 2.0,
              "stress": 3.0
            },
            "success_rate": 0.756,
            "text": "去 Tutorium 问清楚"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_03_和同学对答案",
            "failure_effects": {
              "exam_readiness": -2.0,
              "stress": 6.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 6.0,
              "social": 4.0,
              "stress": 2.0
            },
            "success_rate": 0.513,
            "text": "和同学对答案"
          },
          {
            "choice_id": "exercise_sheet_warning.choice_04_先忙别的",
            "failure_effects": {
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": -3.0,
              "exam_readiness": -8.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "先忙别的"
          }
        ],
        "selected_choice_id": "exercise_sheet_warning.choice_01_补三套练习题"
      },
      "evidence": {
        "decision_request_fingerprint": "fdd8af9e48dba91a1dd05e543706cb6d407f7d9ca116789d9ef3f2335bc7637b",
        "event_request_fingerprint": "dfe8448b6f7a68bafde6d4400794494770674681f2a4b829a417d667d2311964",
        "source_line": 13,
        "source_record_sha256": "231151e4021247761e19ea2b4f4f4eff31a7292eda0602781582b6ac618f66fb"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": 3,
        "blocked_account_balance": -992,
        "loneliness": 3,
        "money": 117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w13",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 14,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 117 EUR，逾期 2628 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 96,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2628,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 60,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 39,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 26,
        "visa_progress": 42,
        "week": 14,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2628,
        "blocked_account_balance": 8928,
        "career_progress": 0,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 57,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 38,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 24,
        "visa_progress": 40,
        "week": 13,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 13
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "visa_status_hidden_check",
              "max_weeks": 14,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 14
            },
            "streak_weeks": 11,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 11 consecutive weeks (week=14).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 14
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "visa_appointment",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": -3,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "visa_progress": 9
      },
      "event": {
        "id": "visa_status_hidden_check",
        "legal_choices": [
          {
            "choice_id": "visa_status_hidden_check.choice_01_立刻联系外管局和学校",
            "failure_effects": {
              "stress": 14.0,
              "visa_progress": -3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "visa_valid",
            "success_effects": {
              "language": 2.0,
              "stress": 9.0,
              "visa_progress": 9.0
            },
            "success_rate": 0.756,
            "text": "立刻联系外管局和学校"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_02_补材料并申请_fiktionsbescheinigung",
            "failure_effects": {
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "visa_valid",
            "success_effects": {
              "stress": 7.0,
              "visa_progress": 7.0
            },
            "success_rate": 0.676,
            "text": "补材料并申请 Fiktionsbescheinigung"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_03_只在网页上继续刷_termin",
            "failure_effects": {
              "stress": 16.0,
              "visa_progress": -4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "deportation_warning",
            "success_effects": {
              "stress": 10.0,
              "visa_progress": 3.0
            },
            "success_rate": 0.436,
            "text": "只在网页上继续刷 Termin"
          },
          {
            "choice_id": "visa_status_hidden_check.choice_04_相信不会查到自己",
            "failure_effects": {
              "stress": 8.0,
              "visa_progress": -12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "deportation_warning",
            "success_effects": {
              "stress": -2.0,
              "visa_progress": -8.0
            },
            "success_rate": 0.366,
            "text": "相信不会查到自己"
          }
        ],
        "selected_choice_id": "visa_status_hidden_check.choice_02_补材料并申请_fiktionsbescheinigung"
      },
      "evidence": {
        "decision_request_fingerprint": "eda7f1409b65522c2872c0fd21958e176819f6fa8d0d386bf57ddc3b7d03d309",
        "event_request_fingerprint": "4c36d3f29e7abb9d0d3f45ab119352a3f9eaed88bc60a2ee4b178c80406ba397",
        "source_line": 14,
        "source_record_sha256": "078d9ddca04eee016f1b5d30bf5f2632f48d69047ea279508199bfe70c151df2"
      },
      "finished": false,
      "full_numeric_delta": {
        "academic_progress": -3,
        "arrears_amount": 138,
        "cash_shortfall_count": 1,
        "loneliness": 3,
        "money": -117,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 9,
        "week": 1
      },
      "id": "w14",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 15,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 2766 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2766,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 63,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 40,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 28,
        "visa_progress": 51,
        "week": 15,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 96,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2628,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 12,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 60,
        "money": 117,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 39,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 26,
        "visa_progress": 42,
        "week": 14,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 14
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "desperate_illegal_work_offer",
              "max_weeks": 15,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 15
            },
            "streak_weeks": 12,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 12 consecutive weeks (week=15).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 15
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "hunger": -8,
        "loneliness": 3,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "desperate_illegal_work_offer",
        "legal_choices": [
          {
            "choice_id": "desperate_illegal_work_offer.choice_01_找学生会紧急援助",
            "failure_effects": {
              "hunger": -8.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -18.0,
              "money": 120.0,
              "social": 2.0,
              "stress": 6.0
            },
            "success_rate": 0.475,
            "text": "找学生会紧急援助"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_03_向同学或父母借钱",
            "failure_effects": {
              "loneliness": 5.0,
              "stress": 16.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -12.0,
              "loneliness": -3.0,
              "money": 260.0,
              "stress": 9.0
            },
            "success_rate": 0.458,
            "text": "向同学或父母借钱"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_04_接下现金黑工",
            "failure_effects": {
              "energy": -25.0,
              "illegal_work_hours": 14.0,
              "stress": 24.0,
              "visa_progress": -8.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "illegal_work_taken",
            "success_effects": {
              "academic_progress": -9.0,
              "energy": -34.0,
              "hunger": -18.0,
              "illegal_work_hours": 36.0,
              "stress": 20.0
            },
            "success_rate": 0.591,
            "text": "接下现金黑工"
          },
          {
            "choice_id": "desperate_illegal_work_offer.choice_05_去食物救助/低价食堂",
            "failure_effects": {
              "hunger": -18.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "hunger": -34.0,
              "money": 20.0,
              "social": -1.0,
              "stress": 8.0
            },
            "success_rate": 0.635,
            "text": "去食物救助/低价食堂"
          }
        ],
        "selected_choice_id": "desperate_illegal_work_offer.choice_01_找学生会紧急援助"
      },
      "evidence": {
        "decision_request_fingerprint": "157d60959155632febe99e4dabc75a500f61ce7effe3155cf03027993cf4dd7b",
        "event_request_fingerprint": "cecc7261f2ef703e366ca7659182eccafb001bdf9766902213d72ab67df7d5ef",
        "source_line": 15,
        "source_record_sha256": "d560a068f1b9cb22315dbcbe47912b9945cd6c7e63570ff6bfd992349d3bbead"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "hunger": -8,
        "loneliness": 3,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w15",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 16,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3021 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "饥饿 92。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 92,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3021,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 92,
        "language": 100,
        "loneliness": 66,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 30,
        "visa_progress": 53,
        "week": 16,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 2766,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 13,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 63,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 40,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 28,
        "visa_progress": 51,
        "week": 15,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 15
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "klausur_countdown",
              "max_weeks": 16,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 16
            },
            "streak_weeks": 13,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 13 consecutive weeks (week=16).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 16
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "hunger": 8,
        "loneliness": 3,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "klausur_countdown",
        "legal_choices": [
          {
            "choice_id": "klausur_countdown.choice_01_整理错题清单",
            "failure_effects": {
              "exam_readiness": 2.0,
              "stress": 9.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.004
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 12.0,
              "stress": 5.0
            },
            "success_rate": 0.466,
            "text": "整理错题清单"
          },
          {
            "choice_id": "klausur_countdown.choice_02_约教授/助教答疑",
            "failure_effects": {
              "stress": 9.0
            },
            "next_event_id": "",
            "requirements": {
              "academic_progress": 0.003,
              "language": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "exam_readiness": 8.0,
              "stress": 3.0
            },
            "success_rate": 0.655,
            "text": "约教授/助教答疑"
          },
          {
            "choice_id": "klausur_countdown.choice_03_和小组模拟考试",
            "failure_effects": {
              "exam_readiness": 1.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "social": 0.003
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 9.0,
              "social": 4.0,
              "stress": 4.0
            },
            "success_rate": 0.542,
            "text": "和小组模拟考试"
          },
          {
            "choice_id": "klausur_countdown.choice_04_继续拖延",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 5.0,
              "exam_readiness": -12.0,
              "stress": -4.0
            },
            "success_rate": 1.0,
            "text": "继续拖延"
          }
        ],
        "selected_choice_id": "klausur_countdown.choice_01_整理错题清单"
      },
      "evidence": {
        "decision_request_fingerprint": "38a3b2a8f1721e2bf9ac334dcff2136d8b568b608bc4e2c329231de38bace971",
        "event_request_fingerprint": "993b42a335e3e10f474b9cd5579c60427aa3233ae56bb4ab22a03c2b658043f2",
        "source_line": 16,
        "source_record_sha256": "81bc6ced6b97d25808bce4da39f6fd1f32bbf2d6ccc947dee4a2887f6f85ee1f"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "hunger": 8,
        "loneliness": 3,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w16",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 17,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3276 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3276,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 69,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 42,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 32,
        "visa_progress": 55,
        "week": 17,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3021,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 14,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 92,
        "language": 100,
        "loneliness": 66,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 41,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 30,
        "visa_progress": 53,
        "week": 16,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 16
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "student_job_offer",
              "max_weeks": 17,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 17
            },
            "streak_weeks": 14,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 14 consecutive weeks (week=17).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 17
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "energy": -16,
        "loneliness": 3,
        "money": 228,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "student_job_offer",
        "legal_choices": [
          {
            "choice_id": "student_job_offer.choice_01_去试工",
            "failure_effects": {
              "energy": -20.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": -20.0,
              "stress": 4.0,
              "work_hours": 8.0
            },
            "success_rate": 1.0,
            "text": "去试工"
          },
          {
            "choice_id": "student_job_offer.choice_02_婉拒",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": -2.0
            },
            "success_rate": 1.0,
            "text": "婉拒"
          },
          {
            "choice_id": "student_job_offer.choice_03_稳妥处理",
            "failure_effects": {
              "career_progress": 1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "career_progress": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.496,
            "text": "稳妥处理"
          },
          {
            "choice_id": "student_job_offer.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "career_progress": 2.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.614,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "student_job_offer.choice_01_去试工"
      },
      "evidence": {
        "decision_request_fingerprint": "afd78c0389d711bb6296c2e885d5a1dc58187adfe029339a5f50de50ad3b3277",
        "event_request_fingerprint": "79433d13b193066c1b1881acceeb9bdd11da693260f1dc847b17eb1f77ca5541",
        "source_line": 17,
        "source_record_sha256": "e4897111fcdee6660ed6afad9056ed33e7ac8ce5f62087f0f929045cb284d69b"
      },
      "finished": false,
      "full_numeric_delta": {
        "annual_work_half_days": 2,
        "blocked_account_balance": -992,
        "energy": -16,
        "loneliness": 3,
        "money": 228,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w17",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 18,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 228 EUR，逾期 3276 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 2,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3276,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 0,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 72,
        "money": 228,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 43,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 34,
        "visa_progress": 57,
        "week": 18,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 0,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3276,
        "blocked_account_balance": 7936,
        "career_progress": 0,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 69,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 42,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 32,
        "visa_progress": 55,
        "week": 17,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 17
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "exam_week",
              "max_weeks": 18,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 18
            },
            "streak_weeks": 15,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 15 consecutive weeks (week=18).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 18
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "cook_at_home",
        "cheap_noodle_week",
        "mensa_coupon",
        "wg_dinner",
        "student_club",
        "classmate_meal",
        "date_night",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "therapy",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "energy": 16,
        "exam_readiness": -3,
        "loneliness": 3,
        "money": -228,
        "social": 1,
        "visa_progress": 2
      },
      "event": {
        "id": "exam_week",
        "legal_choices": [
          {
            "choice_id": "exam_week.choice_01_先做会的题",
            "failure_effects": {
              "exam_readiness": -3.0,
              "stress": 8.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.004,
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 5.0,
              "stress": 4.0
            },
            "success_rate": 0.436,
            "text": "先做会的题"
          },
          {
            "choice_id": "exam_week.choice_02_硬翻译题目",
            "failure_effects": {
              "exam_readiness": -4.0,
              "stress": 12.0
            },
            "next_event_id": "",
            "requirements": {
              "language": 0.004,
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 2.0,
              "language": 3.0,
              "stress": 7.0
            },
            "success_rate": 0.596,
            "text": "硬翻译题目"
          },
          {
            "choice_id": "exam_week.choice_03_先扫整张卷子分配时间",
            "failure_effects": {
              "stress": 7.0
            },
            "next_event_id": "",
            "requirements": {
              "exam_readiness": 0.005
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": 7.0,
              "stress": 2.0
            },
            "success_rate": 0.396,
            "text": "先扫整张卷子分配时间"
          },
          {
            "choice_id": "exam_week.choice_04_盯着第一题死磕",
            "failure_effects": {
              "exam_readiness": -8.0,
              "stress": 14.0
            },
            "next_event_id": "",
            "requirements": {
              "stress": -0.002
            },
            "set_flag": "",
            "success_effects": {
              "exam_readiness": -5.0,
              "stress": 10.0
            },
            "success_rate": 0.096,
            "text": "盯着第一题死磕"
          }
        ],
        "selected_choice_id": "exam_week.choice_01_先做会的题"
      },
      "evidence": {
        "decision_request_fingerprint": "0256cb766883c414a37010d582784c6b9595ccefa757e3f44a8799934a15eff7",
        "event_request_fingerprint": "5a2013d59fc4642f75d34cfcf815c1511c938bea0f8cf710fc1cb285909b89a2",
        "source_line": 18,
        "source_record_sha256": "5a627e1dbb929759181895d8ecfeeebad2c04917b2ae668719e3a9f0787443b4"
      },
      "finished": false,
      "full_numeric_delta": {
        "arrears_amount": 27,
        "cash_shortfall_count": 1,
        "energy": 16,
        "exam_readiness": -3,
        "loneliness": 3,
        "money": -228,
        "social": 1,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w18",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 19,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "压力 100。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 100,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          },
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3303 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 93,
        "annual_work_half_days": 2,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3303,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 16,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 97,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 75,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 44,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 36,
        "visa_progress": 59,
        "week": 19,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 2,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3276,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 15,
        "current_week_work_hours": 0,
        "energy": 0,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 72,
        "money": 228,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 43,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 34,
        "visa_progress": 57,
        "week": 18,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 18
    },
    {
      "anomalies": [
        {
          "evidence": {
            "delta": 34.0,
            "from": 63.0,
            "metric": "hunger",
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "wg_interview",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 4
            },
            "to": 97.0
          },
          "kind": "single_week_spike",
          "message": "`hunger` jumped from 63.0 to 97 in a single week (Δ=+34.0).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 4
        },
        {
          "evidence": {
            "replay": {
              "actions": [
                "problem_set",
                "write_email_practice",
                "library_day",
                "language_tandem"
              ],
              "difficulty": null,
              "event_choice_id": "",
              "event_id": "after_exam_void",
              "max_weeks": 19,
              "policy": "interactive_player",
              "run_id": 0,
              "scenario": null,
              "seed": null,
              "week": 19
            },
            "streak_weeks": 16,
            "threshold": 85.0
          },
          "kind": "hunger_ignored_too_long",
          "message": "Hunger ≥ 85 for 16 consecutive weeks (week=19).",
          "policy": "interactive_player",
          "run_id": 0,
          "severity": "warning",
          "week": 19
        }
      ],
      "attractors": [],
      "available_action_ids": [
        "problem_set",
        "library_day",
        "language_tandem",
        "write_email_practice",
        "watch_german_news",
        "international_office",
        "emergency_international_office",
        "write_formal_email_to_abh",
        "part_time_job",
        "mini_job_extra",
        "scholarship",
        "budget_call",
        "sell_unused_stuff",
        "rent_talk_extension",
        "sleep_recover",
        "go_running",
        "take_a_real_break",
        "bilibili_rest",
        "cv_workshop",
        "apply_howi"
      ],
      "decision": {
        "confidence": 1.0,
        "expected_tradeoff": "deterministic fixture authoring choice",
        "risk_awareness": [
          "registration_delayed",
          "hunger",
          "stress"
        ],
        "strategic_goal": "exercise newbie priorities"
      },
      "delta": {
        "academic_progress": 2,
        "exam_readiness": 3,
        "loneliness": 3,
        "social": 3,
        "stress": -6,
        "visa_progress": 2
      },
      "event": {
        "id": "after_exam_void",
        "legal_choices": [
          {
            "choice_id": "after_exam_void.choice_01_休息半天",
            "failure_effects": {
              "energy": -4.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "energy": 12.0,
              "stress": -10.0
            },
            "success_rate": 1.0,
            "text": "休息半天"
          },
          {
            "choice_id": "after_exam_void.choice_02_立刻复盘",
            "failure_effects": {
              "academic_progress": -1.0,
              "stress": 2.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": 3.0
            },
            "success_rate": 1.0,
            "text": "立刻复盘"
          },
          {
            "choice_id": "after_exam_void.choice_03_稳妥处理",
            "failure_effects": {
              "academic_progress": 1.0,
              "stress": 4.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 3.0,
              "stress": 1.0
            },
            "success_rate": 0.582,
            "text": "稳妥处理"
          },
          {
            "choice_id": "after_exam_void.choice_04_寻求帮助",
            "failure_effects": {
              "social": -1.0,
              "stress": 3.0
            },
            "next_event_id": "",
            "requirements": {},
            "set_flag": "",
            "success_effects": {
              "academic_progress": 2.0,
              "social": 2.0,
              "stress": -2.0
            },
            "success_rate": 0.798,
            "text": "寻求帮助"
          }
        ],
        "selected_choice_id": "after_exam_void.choice_04_寻求帮助"
      },
      "evidence": {
        "decision_request_fingerprint": "c05563767262e09799d214df72443df71e96847b9917fce0c33369dc0a8cd2ee",
        "event_request_fingerprint": "d39bf7430e2ddb198d8942781d2a3ade10ee168abba604660fadde8877471d68",
        "source_line": 19,
        "source_record_sha256": "42ba47f4af48b87bc3f142ba7ad0cacf6e3f9aa77042abb425ba605987eaeab4"
      },
      "finished": true,
      "full_numeric_delta": {
        "academic_progress": 2,
        "arrears_amount": 255,
        "cash_shortfall_count": 1,
        "exam_readiness": 3,
        "loneliness": 3,
        "social": 3,
        "stress": -6,
        "unpaid_social_streak": 2,
        "visa_progress": 2,
        "week": 1
      },
      "id": "w19",
      "kind": "actual",
      "risk_guidance": {
        "contract_version": "1.0",
        "evaluator": "RiskEvaluator.get_top_risks",
        "generated_for_week": 20,
        "source": "game_risk_evaluator",
        "top_risks": [
          {
            "body": "饥饿 100。吃饭问题会持续扣精力、加压力、拖学业。",
            "id": "hunger",
            "score": 100,
            "suggested_actions": [
              "cook_at_home",
              "cheap_noodle_week",
              "mensa_coupon",
              "classmate_meal",
              "wg_dinner"
            ],
            "title": "饥饿/生活"
          },
          {
            "body": "当前可支配现金 0 EUR，逾期 3558 EUR。逾期会推高压力和饥饿，并诱发黑工选择。",
            "id": "money",
            "score": 96,
            "suggested_actions": [
              "rent_talk_extension",
              "budget_call",
              "part_time_job",
              "sell_unused_stuff",
              "cook_at_home"
            ],
            "title": "现金流"
          },
          {
            "body": "压力 94。高压会拖累学业和考试，并可能覆盖普通成功结局。",
            "id": "stress",
            "score": 94,
            "suggested_actions": [
              "take_a_real_break",
              "therapy",
              "sleep_recover",
              "go_running"
            ],
            "title": "压力"
          }
        ]
      },
      "selected_action_ids": [
        "problem_set",
        "write_email_practice",
        "library_day",
        "language_tandem"
      ],
      "state_after": {
        "academic_progress": 95,
        "annual_work_half_days": 2,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3558,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 17,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 100,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 78,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 47,
        "stress": 94,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 38,
        "visa_progress": 61,
        "week": 20,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "state_before": {
        "academic_progress": 93,
        "annual_work_half_days": 2,
        "aps_knowledge": 38,
        "aps_score": 0,
        "arrears_amount": 3303,
        "blocked_account_balance": 6944,
        "career_progress": 0,
        "cash_shortfall_count": 16,
        "current_week_work_hours": 0,
        "energy": 16,
        "exam_readiness": 97,
        "failed_courses": 0,
        "flags": {
          "admin_avoidance": true,
          "arrears": true,
          "arrived_supplied": true,
          "cash_shortfall": true,
          "cashflow_crisis": true,
          "cashflow_warning": true,
          "exam_registered": true,
          "housing_contract_active": true,
          "housing_stable": true,
          "no_close_friends": true,
          "registration_delayed": true,
          "shallow_friendships": true,
          "visa_valid": true,
          "work_law_briefed": true
        },
        "gpa_score": 61,
        "hunger": 100,
        "language": 100,
        "loneliness": 75,
        "money": 0,
        "no_social_streak": 0,
        "parent_pressure": 0,
        "reciprocity_debt": 0,
        "social": 44,
        "stress": 100,
        "testdaf_listening": 2,
        "testdaf_reading": 2,
        "testdaf_speaking": 2,
        "testdaf_writing": 2,
        "university_tier": "未定位",
        "unpaid_social_streak": 36,
        "visa_progress": 59,
        "week": 19,
        "weekly_free_social_actions": 0,
        "weekly_paid_social_actions": 0
      },
      "week": 19
    }
  ],
  "persona": "newbie",
  "provider": "replay",
  "provider_mode": "replay",
  "provider_revision": "fixture:865f4fb83028f7ada18b581462adef3cbb15f2b06ed4c59cb0601f97b0d5f590",
  "scenario": "default_first_semester",
  "schema_version": "playthrough-view-v1",
  "seed": 42,
  "source_trace": {
    "artifact_path": "reports/playthrough-evidence/campaigns/playthrough-evidence-full-v1/cells/newbie-seed-42-800280af3dc4/playthrough.jsonl",
    "artifact_sha256": "5563b484e1178f8d4705c109e3d81a249c573fbcf4ebcead3571e98882dc8d78",
    "record_count": 19
  },
  "stop_reason": "game_finished",
  "truth_label": "prerecorded-real-godot-replay"
}
